@if (station.stationType === stationType.WORKING_AREA && station.stationUsage.transports.length == 0) {
  <app-station-tile [styleClass]="enabled ? 'empty-working-station' : 'disabled'" [isDisabled]="station.stationUsage.disabled"
    [suspended]="station.stationUsage.suspended" [selected]="selected"
    >
    <sc-padding>
      <sc-flex>
        @if (station?.stationUsage?.suspended || station?.stationUsage?.disabled) {
          @if (station?.stationUsage?.suspended) {
            <sc-icon iconClass="fa-lock"></sc-icon>
          }
          @if (station?.stationUsage?.disabled) {
            <sc-icon iconClass="fa-xmark"></sc-icon>
          }
          <sc-content-spacer></sc-content-spacer>
        }
        <div class="label">{{station.name}}</div>
      </sc-flex>
    </sc-padding>
  </app-station-tile>
}

@if (station.stationType === stationType.WORKING_AREA && station.stationUsage.transports.length == 1) {
  <app-station-tile [styleClass]="enabled ? 'used-working-station' : 'disabled'" [selected]="selected"
    >
    <sc-padding>
      <sc-flex>
        @if (station?.stationUsage?.transports.length > 0) {
          <app-transport-scope-icon [scope]="transport.scope"></app-transport-scope-icon>
          <sc-content-spacer></sc-content-spacer>
        }
        <div class="label">{{station.name}}</div>
      </sc-flex>
    </sc-padding>
  </app-station-tile>
}

@if (station.stationType === stationType.WAITING_AREA) {
  <app-station-tile [styleClass]="enabled ? 'waiting-area' : 'disabled'" [selected]="selected"
    >
    <sc-padding>
      <sc-flex>
        @if (station?.stationUsage?.suspended || station?.stationUsage?.disabled) {
          @if (station?.stationUsage?.suspended) {
            <sc-icon iconClass="fa-lock"></sc-icon>
          }
          @if (station?.stationUsage?.disabled) {
            <sc-icon iconClass="fa-xmark"></sc-icon>
          }
          <sc-content-spacer></sc-content-spacer>
        }
        <div class="label">{{station.name}}</div>
        <sc-content-spacer grow></sc-content-spacer>
        <div>{{station?.stationUsage?.transports?.length}} / {{station?.capacity}}</div>
      </sc-flex>
    </sc-padding>
  </app-station-tile>
}
